import { useEffect } from "react";
import { pageTitle, imgUrl } from "../../helper";
import PageHeading from "../PageHeading";
import Div from "../Div";
import SectionHeading from "../SectionHeading";
import Spacing from "../Spacing";
import Team from "../Team";
const advisoryData = [
  {
    memberImage: "/images/thomas.png",
    memberName: "Thomas Vu",
    memberDesignation:
      "Strategic Advisor | IP Expansion and<br/>Business Strategy",
    memberLogo: "/images/thomas-logo.png",
    memberSocial: {
      linkedin: "https://www.linkedin.com/in/thomashasfullheart/",
    },
  },
  {
    memberImage: "/images/anthony.png",
    memberName: "Anthony Borquez",
    memberDesignation: "Strategic Advisor | Studio Growth and<br/>Expansion",
    memberLogo: "/images/anthony-logo.png",
    memberSocial: {
      linkedin: "https://www.linkedin.com/in/anthony-borquez-81283070/",
    },
  },
  {
    memberImage: "/images/mario.png",
    memberName: "Mario Rizzo",
    memberDesignation: "Strategic Advisor | Game Development & Studio Strategy",
    memberLogo: "/images/mario-logo.png",
    memberSocial: {
      linkedin: "https://www.linkedin.com/in/mariorizzo/",
    },
  },
  {
    memberImage: "/images/sohail.png",
    memberName: "Dr. Sohail Munir",
    memberDesignation:
      "Strategic Advisor | Government Innovation & Emerging Technologies",
    memberLogo: "/images/sohail-logo.png",
    memberSocial: {
      linkedin: "https://www.linkedin.com/in/sohailmunir/",
    },
  },
  {
    memberImage: "/images/ahmed.png",
    memberName: "Ahmed Galal CFA CPA",
    memberDesignation:
      "Strategic Advisor | Financial Governance & Risk Management",
    memberLogo: "/images/ahmed-logo.png",
    memberSocial: {
      linkedin: "https://www.linkedin.com/in/ahmed-galal77/",
    },
  },
];

export default function TeamPage() {
  pageTitle("Team");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageHeading
        title="Team"
        bgSrc="/images/team_hero_bg.jpeg"
        pageLinkText="Team"
      />
      <Spacing lg="145" md="80" />
      <Div className="container">
        <Spacing lg="90" md="45" />
        <Div className="container">
          <Div className="row align-items-center">
            <Div className="col-xl-4 col-lg-4">
              <Div className="cs-radius_15 cs-shine_hover_1">
                <img
                  src={imgUrl("/images/faisal.png")}                   alt="Member"
                  className="w-100"
                />
              </Div>
            </Div>
            <Div className="col-lg-7 offset-xl-1">
              <Spacing lg="0" md="45" />
              <Div className="cs-section_heading cs-style1">
                <h2 className="">
                  A Letter from the President
                </h2>
                <Div className="cs-separator cs-accent_bg" />
                <Div className="cs-height_25 cs-height_lg_25" />
                <p className="cs-m0">
                  We are entering a new era, where imagination is the only
                  limit.
                </p>
                <Div className="cs-height_10 s-height_lg_20" />
                <p className="cs-m0">
                  At Dreamscript Technologies, we are building the
                  infrastructure for that future, systems that turn ideas into
                  reality, at speed, at scale, without friction.
                </p>
                <Div className="cs-height_10 s-height_lg_20" />
                <p className="cs-m0">
                  The name Dreamscript reflects our belief. Every idea begins as
                  a dream, but it is the ability to script it, to structure it,
                  build it, and bring it to life, that defines the future. We
                  exist to bridge that gap, between imagination and
                  execution.{" "}
                </p>
                <Div className="cs-height_10 s-height_lg_20" />
                <p className="cs-m0">
                  This is not about technology alone. It is about potential,
                  waiting to be unlocked, shaped, and brought to life.
                </p>
                <Div className="cs-height_10 s-height_lg_20" />
                <p className="cs-m0">This is just the beginning.</p>
                <Div className="cs-height_25 cs-height_lg_30" />
                <h5 className="cs-m0">Faisal Zaidi</h5>
                <p className="cs-m0">President, Dreamscript Technologies</p>
              </Div>
            </Div>
          </Div>
        </Div>
        <Spacing lg="70" md="50" />
        <SectionHeading
          title="Advisor"
          subtitle=""
          variant="cs-style1 text-center"
        />
        <Spacing lg="90" md="45" />
        <Div className="row">
          {advisoryData.map((item, index) => (
            <Div key={index} className="col-lg-3 col-sm-6">
              <Team
                memberImage={item.memberImage}
                memberName={item.memberName}
                memberDesignation={item.memberDesignation}
                memberSocial={item.memberSocial}
                memberLogo={item.memberLogo}
              />
              <Spacing lg="80" md="30" />
            </Div>
          ))}
        </Div>
        <Spacing lg="70" md="50" />
      </Div>
    </>
  );
}
